import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { roleStr, roleInfo } from '../../../common/common';
import LevelChoose from '../../Components/LevelChoose';
import Participate from '../../Components/Participate';
import UserAutoComplete from '../../Components/UserAutoComplete';
import { getNowDate } from '../../../common/utils';
import lImg from '../../../assets/illustration-referror.png';
import rImg from '../../../assets/illustration-referee.png';
import logo from '../../../assets/mark-mtlawllc.png';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .textField2': {
        width: '45%',
        marginRight: '30px',
        backgroundColor: '#FFFFFF',
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .btn-area': {
        width: '100%',
        textAlign: 'center',
        padding: '20px',
        '& .btn-wapper': {
            width: '340px',
            position: 'relative',
            padding: '20px',
            boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.1)',
            borderRadius: '28px',
            cursor: 'pointer',
            '& .title': {
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#9B9B9B',
            },
            '& .lImg': {
                width: '238px',
                height: '238px',
                background: `url(${lImg}) no-repeat center top/cover`,
            },
            '& .rImg': {
                width: '238px',
                height: '238px',
                background: `url(${rImg}) no-repeat center top/cover`,
            },
            '& .logoImg': {
                width: '69px',
                height: '16px',
                position: 'absolute',
                right: '30px',
                bottom: '20px',
                background: `url(${logo}) no-repeat center top/cover`,
            },
            '& .btn-line': {
                width: '100%',
                height: '1px',
                backgroundColor: '#9B9B9B',
                margin: '20px 0',
            },
        },
        '& .btn-wapper:hover': {
            backgroundColor: '#1A9AE7',
            color: '#fff',
            '& .title': {
                color: '#fff',
            },
            '& .btn-line': {
                backgroundColor: '#fff',
            }
        },
        '& .role-btn': {
            fontSize: '15px',
            margin: '0 30px'
        }
    },
    '& .textWapper2': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.13',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const ADD = 0;
const VIEW = 1;
const EDIT = 2;

class ReferralInfoAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            member: null,
            referer_id: null,//(推荐人)
            referee_id: null,//(接收人)
            client_note: "",
            client_name: "",
            client_phone: "",
            client_email: "",
            case_type: "",
            referral_date: getNowDate(),
            btnName: this.btnName(this.props.state),
            step: 0,
            isReferor: true
        };
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.handleTitleText = this.handleTitleText.bind(this);
    }

    render() {
        const {
            member,
            client_note,
            client_name,
            client_phone,
            client_email,
            case_type,
            referral_date,
            step,
            isReferor
        } = this.state,
            showCreateBtn = () => {
                if (!this.isDisabled()) {
                    return <Button variant="contained" color="primary"
                        onClick={this.handleCreate}>{this.state.btnName}</Button>
                }
            },
            chooseRole = () => {
                return <div className="c">
                    <div className="btn-area h h-bt">
                        <div className="btn-wapper c" onClick={() => this.nextStep(true)}>
                            <div className="title">I am the Referor</div>
                            <div className="btn-line"></div>
                            <div className="lImg"></div>
                            <div className="logoImg"></div>
                        </div>
                        <div className="btn-wapper c" onClick={() => this.nextStep(false)}>
                            <div className="title">I am the Referee</div>
                            <div className="btn-line"></div>
                            <div className="rImg"></div>
                            <div className="logoImg"></div>
                        </div>
                    </div>
                    <div className="line"></div>
                    <Button className="role-btn" variant="contained" onClick={this.handleCancel}>cancel</Button>
                </div>
            },
            fillInfo = () => {
                return <div>
                    <div className="title">Referral Info</div>
                    <div className="flow">
                        <div className="textWapper2">
                            <div className="textTitle">Date of Referral</div>
                            <TextField
                                type="date"
                                disabled={this.isDisabled()}
                                className="textField"
                                value={referral_date}
                                onChange={e => this.handleChange(e, "referral_date")}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="textWapper2">
                            {this.handleTitleText(isReferor)}
                            <UserAutoComplete
                                initUser={member}
                                update={this.updateMember}
                            />
                        </div>
                    </div>
                    <div className="title">Client Info</div>
                    <div className="flow">
                        <div className="textWapper2">
                            <div className="textTitle">Client name</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="textField"
                                value={client_name}
                                onChange={e => this.handleChange(e, "client_name")}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="textWapper2">
                            <div className="textTitle">Client email</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="textField"
                                value={client_email}
                                onChange={e => this.handleChange(e, "client_email")}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="textWapper2">
                            <div className="textTitle">Client phone number</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="textField"
                                value={client_phone}
                                onChange={e => this.handleChange(e, "client_phone")}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="textWapper2">
                            <div className="textTitle">Type of case</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="textField"
                                value={case_type}
                                onChange={e => this.handleChange(e, "case_type")}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="textWapper">
                            <div className="textTitle">Client Note</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="textFieldF"
                                multiline
                                rows="3"
                                value={client_note}
                                onChange={e => this.handleChange(e, "client_note")}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                    </div>
                    <div className="line"></div>
                    <div className="foot h h-r">
                        <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                        {showCreateBtn()}
                    </div>
                </div>
            },
            stepArea = () => {
                if (step === 0) {
                    return chooseRole();
                }
                return fillInfo()
            };


        return (
            <Root>
                <div className="pageTitle">{this.props.title}</div>
                <div className="line"></div>
                {stepArea()}
            </Root>
        )
    }

    componentDidMount() {
        this.initData();
    }

    initData() {
        const { state, data } = this.props;
        console.log(data);
        if (state === VIEW || state === EDIT) {
            const number = data.number;
            const numberCopy = data.number;
            const name = data.name;
            const note = data.note ? data.note : "";
            this.setState(() => ({
                number,
                numberCopy,
                name,
                note,
            }))
        }
    }

    nextStep(isReferor) {
        this.setState(() => ({
            isReferor,
            step: 1
        }));
    }

    updateMember(member) {
        this.setState(() => ({
            member
        }));
    }

    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }

    isMatterDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return true;
        }
    }

    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }

    handleTitleText(isReferor) {
        return <div className="textTitle">Choose {isReferor ? "Referee" : "Referor"}</div>;
    }

    handleCreate() {
        const {
            member,
            client_note,
            client_name,
            client_phone,
            client_email,
            case_type,
            referral_date,
            isReferor
        } = this.state;
        let obj = {
            referer_id: isReferor ? roleInfo.identity.id : member.id,//(推荐人)
            referee_id: isReferor ? member.id : roleInfo.identity.id,//(接收人)
            client_note,
            client_name,
            client_phone,
            client_email,
            case_type,
            referral_date,
        }
        this.props.handleCreate(obj);
    }

    handleCancel() {
        this.props.handleCancel();
    }

    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }

    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
}

export default ReferralInfoAdd;